import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Members from './components/Members';
import Services from './components/Services';
import FAQ from './components/FAQ';
import ContactUS from './components/ContactUs';
import Footer from './components/Footer';


const pageVariants = {
  initial: {
    opacity: 0,
    x: -20
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut"
    }
  },
  exit: {
    opacity: 0,
    x: 20,
    transition: {
      duration: 0.3,
      ease: "easeIn"
    }
  }
};

const PageWrapper = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    {children}
  </motion.div>
);

const App = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#F6EAD1] to-[#99BAD4] overflow-hidden">
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={
            <PageWrapper>
              <Hero />
              <Features />
              <Members />
              <Services />
              <FAQ />
              <ContactUS />
            </PageWrapper>
          } />
          <Route path="/about" element={
            <PageWrapper>
              <Features />
            </PageWrapper>
          } />
          <Route path="/services" element={
            <PageWrapper>
              <Services />
            </PageWrapper>
          } />
          <Route path="/contact" element={
            <PageWrapper>
              <ContactUS />
            </PageWrapper>
          } />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
};

export default App;
